const ticket = {
  reply: 'ticket/reply-by-admin',
  getlist: 'ticket/getlist-by-admin',
  get: 'ticket/get-by-admin',
  update: 'ticket/update',
  changeVisibility: 'ticket/change-visibility',
  openTicket: 'ticket/add-by-admin'
}
export default ticket
